import { Component, OnInit } from '@angular/core';
import { DashboardService } from 'src/app/services/dashboard/dashboard.service';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import * as Highcharts from 'highcharts';
import { LoadingEfectComponent } from 'src/app/Layout/loading-efect/loading-efect.component';
import { AuthService } from 'src/app/services/login/auth/auth.service';
import { UsuariosService } from 'src/app/services/usuarios/usuarios.service';
import { ActivatedRoute, Router } from '@angular/router';

declare var require: any;
let Boost = require('highcharts/modules/boost');
let noData = require('highcharts/modules/no-data-to-display');
let More = require('highcharts/highcharts-more');
let Solid = require('highcharts/modules/solid-gauge');
let Exporting = require('highcharts/modules/exporting');
let Export = require('highcharts/modules/export-data');
let Accessibility = require('highcharts/modules/accessibility');
let Drilldown = require('highcharts/modules/drilldown');

Boost(Highcharts);
noData(Highcharts);
More(Highcharts);
Solid(Highcharts);
Exporting(Highcharts);
Export(Highcharts);
Accessibility(Highcharts);
Drilldown(Highcharts);

@Component({
  selector: 'app-dashboardco',
  templateUrl: './dashboardco.component.html',
  styleUrls: ['./dashboardco.component.css']
})
export class DashboardcoComponent implements OnInit {
  loading = new LoadingEfectComponent();
  public flagEXT = this._route.snapshot.paramMap.get('id');
  public tipoDetalle = 'SOLO MANDATORIOS';
  public obj:any = {
    DG: {
      PERTOTAL:0
    }
  };
  series:any;
  renderer:any;
  chartWidth:any;
  plotHeight:any;

  identity = JSON.parse(localStorage.getItem('identity_user'));

  constructor(
    private _service:DashboardService,
    private _auth: AuthService,
    private _serviceUsuario:UsuariosService,
    private _route: ActivatedRoute,
    private _router: Router
  ) { }

  ngOnInit(){
    // get html body element
    const bodyElement = document.body;
    if (bodyElement) {
      bodyElement.classList.add("body-dash");
    }
    this._route.params.subscribe(
        params => {
            this.flagEXT = params['id'];
            this.registrarLog();
            this.verifyClaims();
            this.getRegistros();
            this.loading.onDoneRequest();
        }
    );
  }

  public registrarLog(){
    let clase = 'Dashboard ' + this.flagEXT;
    let obj = {
      //Controller: obj.Controller,
      Class: clase,
      //Table: obj.Table,
      //ID: obj.ID,
      Message: 'ACCESO'
    }
    this._serviceUsuario.registrarLog(obj);
  }

  ngOnDestroy() {
    // remove the class form body tag
    const bodyElement = document.body;
    if (bodyElement) {
      bodyElement.classList.remove("body-dash");
    }
  }

  verifyClaims(){
    var claim = this.identity.permisoLists.find(x => x.nombrePermiso === 'Dashboard');
    if(claim == undefined && claim == null){
      this._router.navigate(['/sa-rm/admin']);
    }
  }

  public getRegistros(){
    this.loading.onLoadingRequest();
    this._service.getDashboardGeneral(this.identity.NombreRol, 0, this.flagEXT)
    .then(response=>{
      this.loading.onDoneRequest();
      if(response.status == 200){
        this.obj = response
        const factor = 10 ** 2;
        this.obj.DG.PEROperaciones = Math.round(this.obj.DG.PEROperaciones * factor)/ factor;
        this.obj.DG.PERContrato = Math.round(this.obj.DG.PERContrato * factor)/ factor;
        this.obj.DG.PERDeseable = Math.round(this.obj.DG.PERDeseable * factor)/ factor;
        this.obj.DG.PERTOTAL = Math.round(this.obj.DG.PERTOTAL * factor)/ factor;
        console.log(response);
        this.graph();
      }else if(response.status == 500){
        Swal.fire("Error",response.message,"error");
      }
    })
    .catch(error=>{
      this.loading.onDoneRequest();
      console.log(error.toString());
    });
  }

  public graph(){
    var opciones:any = {
      chart: {
          type: 'solidgauge',
          height: '110%',
          backgroundColor: 'transparent'
      },
      title: {
        text: ''
      },
      tooltip: {
          borderWidth: 0,
          backgroundColor: 'none',
          shadow: false,
          style: {
              fontSize: '16px',
              color: 'black'
          },
          valueSuffix: '%',
          pointFormat: '{series.name}<br><span style="font-size:2em; color: {point.color}; font-weight: bold">{point.y}</span>',
          positioner: function (labelWidth) {
              return {
                  x: (this.chart.chartWidth - labelWidth) / 2,
                  y: (this.chart.plotHeight / 2) - 25
              };
          }
      },
      pane: {
          startAngle: 0,
          endAngle: 360,
          background: [{ // Track for Move
              outerRadius: '112%',
              innerRadius: '88%',
              backgroundColor: Highcharts.color("#D40511")
                  .setOpacity(0.3)
                  .get(),
              borderWidth: 0
          }, { // Track for Exercise
              outerRadius: '87%',
              innerRadius: '63%',
              backgroundColor: Highcharts.color("#FFEA90")
                  .get(),
              borderWidth: 0
          }, { // Track for Stand
              outerRadius: '62%',
              innerRadius: '38%',
              backgroundColor: Highcharts.color(Highcharts.getOptions().colors[1])
                  .setOpacity(0.3)
                  .get(),
              borderWidth: 0
          }]
      },
      yAxis: {
          min: 0,
          max: 100,
          lineWidth: 0,
          tickPositions: []
      },
      plotOptions: {
          solidgauge: {
              dataLabels: {
                  enabled: false
              },
              linecap: 'round',
              stickyTracking: false,
              rounded: true
          }
      },
      credits:{
        enabled: false
      },
      series: [{
          name: 'Mandatorios para contrato',
          data: [{
              color: "#D40511",
              radius: '112%',
              innerRadius: '88%',
              y: this.obj.DG.PERContrato
          }]
      }, {
          name: 'Mandatorios para visita de certificación',
          data: [{
              color: "#FFCC00",
              radius: '87%',
              innerRadius: '63%',
              y: this.obj.DG.PEROperaciones
          }]
      }, {
          name: 'No mandatorios',
          data: [{
              color: "black",
              radius: '62%',
              innerRadius: '38%',
              y: this.obj.DG.PERDeseable
          }]
      }]
    }

    Highcharts.chart('graphCo', opciones);
  }

  public getRegistrosMandatorios(){
    if(this.tipoDetalle == 'SOLO MANDATORIOS'){
      this.tipoDetalle = 'COMPLETO';
      this.loading.onLoadingRequest();
      this._service.getDashboardGeneral_Mandatorios(this.identity.NombreRol, 0, this.flagEXT)
      .then(response=>{
        this.loading.onDoneRequest();
        if(response.status == 200){
          const factor = 10 ** 2;
          this.obj.DG.PEROperaciones = Math.round(response.DG.PEROperaciones * factor)/ factor;
          this.obj.DG.PERContrato = Math.round(response.DG.PERContrato * factor)/ factor;
          this.obj.DG.PERTOTAL = Math.round((response.DG.PEROperaciones + response.DG.PERContrato) * factor)/ factor;
          console.log(response);
          this.graph2();
        }else if(response.status == 500){
          Swal.fire("Error",response.message,"error");
        }
      })
      .catch(error=>{
        this.loading.onDoneRequest();
        console.log(error.toString());
      });
    }else{
      this.tipoDetalle = 'SOLO MANDATORIOS';
      this.getRegistros();
    }
  }

  public graph2(){
    var opciones:any = {
      chart: {
          backgroundColor: 'transparent'
      },
      title: {
        text: ''
      },
      tooltip: {
          borderWidth: 0,
          shadow: false,
          style: {
              fontSize: '16px',
              color: 'black'
          },
          valueSuffix: '%',
          pointFormat: '{series.name}<br>{point.name}<br><span style="font-size:2em; color: {point.color}; font-weight: bold">{point.y}</span>'
      },
      pane: {
          startAngle: 0,
          endAngle: 360,
          background: [{ // Track for Move
              outerRadius: '112%',
              innerRadius: '88%',
              backgroundColor: Highcharts.color("#D40511")
                  .setOpacity(0.3)
                  .get(),
              borderWidth: 0
          }, { // Track for Exercise
              outerRadius: '87%',
              innerRadius: '63%',
              backgroundColor: Highcharts.color("#FFEA90")
                  .get(),
              borderWidth: 0
          }, { // Track for Stand
              outerRadius: '62%',
              innerRadius: '38%',
              backgroundColor: Highcharts.color(Highcharts.getOptions().colors[1])
                  .setOpacity(0.3)
                  .get(),
              borderWidth: 0
          }]
      },
      plotOptions: {
          pie: {
              dataLabels: {
                  enabled: true,
                  distance: -50,
                  style: {
                      fontWeight: 'bold',
                      color: 'white'
                  }
              },
              startAngle: -90,
              endAngle: 90,
              center: ['50%', '75%'],
              size: '110%'
          }
      },
      credits:{
        enabled: false
      },
      series: [{
        type: 'pie',
        name: 'Mandatorios',
        innerSize: '50%',
        data: [
            {
                name: 'Contrato',
                y: this.obj.DG.PERContrato,
                color: "#D40511",
                dataLabels: {
                    enabled: false
                }
            },
            {
                name: 'Visita de certificación',
                y: this.obj.DG.PEROperaciones,
                color: "#FFCC00",
                dataLabels: {
                    enabled: false
                }
            },
            {
                name: 'No contestados o sin certificar',
                y: 100 - this.obj.DG.PERTOTAL,
                color: "black",
                dataLabels: {
                    enabled: false
                }
            }
        ]
      }]
    }

    Highcharts.chart('graphCo', opciones);
  }

  gotoDashboard(tipo:number){
    if(tipo == 1){
      this._router.navigate(['/sa-rm/admin/dashboard-area/' + this.flagEXT]);
    }else{
      this._router.navigate(['/sa-rm/admin/dashboard-empresa/' + this.obj.rolcheck + ',' + this.flagEXT]);
    }
  }
}
